import React, { useMemo, useContext } from "react";
import { useStore } from "stores/connect";
import { Button } from "components/bootstrap";
import ForwardersContext from "../forwarders/ForwardersContext";
import ForwarderInputStatesStore, { ForwarderInputStatesActions } from "../stores/ForwarderInputStatesStore";
const ForwarderInputStateControl = ({ input, forwarder }) => {
  const { forwarderInputStates } = useStore(ForwarderInputStatesStore);
  const { getForwarderContext } = useContext(ForwardersContext);
  const { state: forwarderState } = getForwarderContext(forwarder.id);
  const inputState = useMemo(() => {
    const statesByInput = (forwarderInputStates || []).filter((state) => state.input_id === input.id).filter((state) => state.forwarder_id === forwarder.id).map((state) => state.state);
    return statesByInput.length > 0 ? statesByInput[0] : void 0;
  }, [input, forwarder, forwarderInputStates]);
  if (forwarderState !== "CONNECTED") {
    return /* @__PURE__ */ React.createElement(Button, { bsStyle: "default", disabled: true }, "Forwarder is not connected");
  }
  if (inputState === "RUNNING" || inputState === "FAILING") {
    return /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => ForwarderInputStatesActions.stopInput(forwarder, input) }, "Stop input");
  }
  return /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => ForwarderInputStatesActions.startInput(forwarder, input) }, "Start input");
};
export default ForwarderInputStateControl;
